import styled from 'styled-components';

const Img = styled.img`
  height: auto;
  width: 100%;
  object-fit: cover;
`;

export default Img;
